export enum DataProviderEntity {
    Sites = 'sites',
    Crops = 'crops',
    Packagings = 'packagings',
    TaskTypes = 'taskTypes',
    Companies = 'companies',
    Warehouses = 'warehouses',
    ProductionLines = 'productionLines',
};
